export default __webpack_public_path__ + "static/media/flow_1.475184c1.jpg";